import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function resetWindowScroll() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

function scrollToId(id) {
  const node = document.getElementById(id);
  if (!node) return false;
  node.scrollIntoView({ behavior: 'auto', block: 'start' });
  return true;
}

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    resetWindowScroll();

    const id = hash === '#comments' ? 'comments' : '';
    if (!id) return undefined;

    let tries = 0;
    let timer = window.setTimeout(function tick() {
      if (scrollToId(id) || tries >= 24) return;
      tries += 1;
      timer = window.setTimeout(tick, 160);
    }, 40);

    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
